module.exports = __webpack_public_path__ + "media/components/src/assets/images/shopping_cart/img-cart-7ccf857c1f84a6385952c21a45883c69.svg";